// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Ukpdu7-m7tCZUIbIgqDqm"};